var _path, _path2, _mask, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _mask2, _g2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _mask3, _g3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlideContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 313,
    viewBox: "0 0 304 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.994 116.938L112.784 114.491L101.887 92.2395L106.097 94.6865L116.994 116.938Z",
    fill: "#4CD964"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.636 4.76761C152.952 1.69761 157.277 4.16261 157.294 10.2716L157.417 53.9756C157.435 60.0846 153.139 67.5256 147.823 70.5956L127.738 82.1916L116.993 116.938L106.096 94.6866L86.0106 106.283C80.6936 109.352 76.3696 106.888 76.3526 100.779L76.2286 57.0746C76.2116 50.9646 80.5076 43.5236 85.8236 40.4546L147.636 4.76761Z",
    fill: "#26C642"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 1,
    width: 83,
    height: 106
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0186 1H154.486V106.953H72.0186V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.276 1.65004C148.525 0.632043 146.101 0.776043 143.425 2.32104L81.6136 38.007C76.2966 41.077 72.0016 48.518 72.0186 54.628L72.1426 98.331C72.1506 101.366 73.2226 103.502 74.9506 104.506L79.1606 106.953C77.4326 105.949 76.3616 103.814 76.3526 100.778L76.2296 57.074C76.2116 50.964 80.5076 43.524 85.8246 40.454L147.636 4.76804C150.311 3.22304 152.736 3.07904 154.486 4.09704L150.276 1.65004Z",
    fill: "#4CD964"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.348 71.8291C126.743 71.0241 127.742 71.5371 127.745 72.9951C127.749 74.4281 126.757 76.1781 125.363 76.9841C123.967 77.7891 122.968 77.1881 122.964 75.7551C122.96 74.2971 123.952 72.6351 125.348 71.8291Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.03 56.5361C128.766 54.3791 131.359 54.8021 131.369 58.1781C131.382 62.7541 127.198 65.6852 127.207 68.7221L123.448 70.8911C123.437 66.8871 127.319 63.7521 127.311 61.2631C127.307 59.8611 126.233 59.5942 124.614 60.5292C123.021 61.4482 121.804 62.9571 121.009 64.7322L117.989 64.4422C119.328 61.3202 121.665 58.4781 125.03 56.5361Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2061 68.4004C98.6011 67.5954 99.6051 68.1044 99.6091 69.5694C99.6131 70.9964 98.6151 72.7504 97.2201 73.5554C95.8311 74.3574 94.8321 73.7564 94.8281 72.3294C94.8241 70.8654 95.8161 69.2034 97.2061 68.4004Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8885 53.1074C100.625 50.9504 103.223 51.3704 103.233 54.7464C103.246 59.3284 99.0625 62.2604 99.0705 65.2904L95.3065 67.4624C95.2955 63.4594 99.1825 60.3264 99.1755 57.8374C99.1715 56.4294 98.0965 56.1624 96.4775 57.0974C94.8855 58.0164 93.6685 59.5244 92.8735 61.2994L89.8535 61.0094C91.1925 57.8884 93.5295 55.0464 96.8885 53.1074Z",
    fill: "#F1F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.452 28.647C140.188 26.49 142.781 26.913 142.791 30.289C142.805 34.865 138.621 37.796 138.629 40.833L134.871 43.002C134.859 38.999 138.741 35.863 138.734 33.374C138.73 31.972 137.655 31.705 136.036 32.64C134.444 33.559 133.226 35.068 132.431 36.843L129.411 36.553C130.751 33.431 133.088 30.589 136.452 28.647Z",
    fill: "#B8E986"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.77 43.9399C138.166 43.1349 139.164 43.6479 139.168 45.1059C139.172 46.5389 138.18 48.2899 136.785 49.0949C135.39 49.8999 134.391 49.2989 134.386 47.8659C134.382 46.4079 135.375 44.7459 136.77 43.9399Z",
    fill: "#B8E986"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.737 69.9849C113.127 69.1829 114.126 69.6949 114.13 71.1599C114.133 72.5869 113.141 74.3369 111.752 75.1389C110.357 75.9449 109.352 75.3469 109.348 73.9209C109.344 72.4559 110.342 70.7899 111.737 69.9849Z",
    fill: "#B8E986"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.274 67.0636L110.183 68.8486L109.375 56.2186L114.008 53.5436L113.274 67.0636Z",
    fill: "#B8E986"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.232 41.6114C123.627 40.8054 124.626 41.3184 124.629 42.7774C124.634 44.2104 123.641 45.9604 122.247 46.7654C120.851 47.5714 119.852 46.9704 119.848 45.5374C119.844 44.0794 120.836 42.4164 122.232 41.6114Z",
    fill: "#F1F1F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.769 38.6899L120.678 40.4749L119.87 27.8449L124.503 25.1699L123.769 38.6899Z",
    fill: "#F1F1F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.184 171.771C232.425 170.755 230.996 171.569 230.991 173.59C230.985 175.612 232.404 178.07 234.163 179.085C235.922 180.101 237.351 179.288 237.356 177.266C237.362 175.245 235.943 172.787 234.184 171.771Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.184 157.391C232.425 156.375 230.996 157.189 230.991 159.21C230.985 161.232 232.404 163.69 234.163 164.705C235.922 165.721 237.351 164.907 237.356 162.885C237.362 160.865 235.943 158.407 234.184 157.391Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.184 143.01C232.425 141.994 230.996 142.809 230.991 144.83C230.985 146.852 232.404 149.309 234.163 150.324C235.922 151.34 237.351 150.527 237.356 148.505C237.362 146.484 235.943 144.026 234.184 143.01Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.292 190.054C249.532 189.038 248.104 189.853 248.099 191.874C248.093 193.896 249.512 196.353 251.271 197.368C253.03 198.384 254.458 197.571 254.464 195.549C254.47 193.528 253.051 191.07 251.292 190.054Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.292 175.674C249.532 174.658 248.104 175.472 248.099 177.493C248.093 179.515 249.512 181.973 251.271 182.988C253.03 184.004 254.458 183.191 254.464 181.169C254.47 179.148 253.051 176.69 251.292 175.674Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.523 305.152C280.763 304.136 279.335 304.95 279.33 306.971C279.324 308.993 280.743 311.451 282.502 312.466C284.261 313.482 285.69 312.669 285.695 310.647C285.701 308.626 284.282 306.168 282.523 305.152Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.523 292.772C280.763 291.756 279.335 292.57 279.33 294.591C279.324 296.613 280.743 299.071 282.502 300.086C284.261 301.102 285.69 300.288 285.695 298.266C285.701 296.245 284.282 293.788 282.523 292.772Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.906 272.017L280.429 269.969L271.922 281.937L268.398 283.985L276.906 272.017Z",
    fill: "#26C642"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 238,
    y: 200,
    width: 66,
    height: 82
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.798 200.15H303.915V281.912H238.798V200.15Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.858 229.697L247.365 201.122C245.395 199.985 243.611 199.879 242.322 200.628L238.798 202.676C240.087 201.927 241.871 202.033 243.84 203.17L293.335 231.745C297.242 234.001 300.405 239.479 300.392 243.976L300.297 277.372C300.291 279.602 299.503 281.173 298.231 281.912L301.754 279.864C303.026 279.125 303.815 277.554 303.821 275.324L303.916 241.928C303.928 237.431 300.766 231.953 296.858 229.697Z",
    fill: "#26C642"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.334 231.745C297.241 234.001 300.404 239.479 300.392 243.976L300.297 277.372C300.284 281.862 297.101 283.677 293.193 281.42L276.906 272.016L268.398 283.984L259.98 262.245L243.699 252.845C239.785 250.585 236.622 245.107 236.636 240.617L236.73 207.222C236.743 202.724 239.926 200.91 243.84 203.17L293.334 231.745Z",
    fill: "#4CD964"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.885 227.505C258.465 228.994 260.178 231.504 260.171 233.918C260.167 235.209 259.851 236.21 258.225 236.997L255.554 238.351L260.528 241.223L260.521 243.732L251.78 238.685L251.785 236.69L256.262 234.424C257.287 233.892 257.474 233.316 257.476 232.67C257.479 231.621 256.849 230.648 255.629 229.943C254.64 229.372 253.789 229.321 253.225 229.893L251.281 227.323C252.18 226.335 253.797 226.299 255.885 227.505Z",
    fill: "#F1F1F1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.637 235.672L264.558 240.749L267.667 242.545L267.674 240.058L270.202 241.518L270.196 244.004L272.079 245.092L272.072 247.601L270.189 246.514L270.181 249.309L267.57 247.801L267.577 245.006L261.346 241.408L261.352 239.339L266.828 234.05L269.637 235.672Z",
    fill: "#F1F1F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.023 238.565L276.009 243.502C276.708 243.105 277.699 243.258 278.841 243.919C280.935 245.127 282.521 247.454 282.512 250.564L282.496 256.419L279.917 254.929L279.932 249.53C279.936 247.879 279.275 246.74 278.138 246.084C276.9 245.369 276.003 245.726 275.998 247.604L275.984 252.659L273.404 251.169L273.444 237.077L276.023 238.565Z",
    fill: "#F1F1F1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.004 170.468L195.528 168.42L187.021 180.388L183.497 182.436L192.004 170.468Z",
    fill: "#26C642"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.957 128.148L162.464 99.5735C160.494 98.4355 158.71 98.3305 157.421 99.0795L153.896 101.127C155.186 100.377 156.97 100.483 158.939 101.621L208.434 130.196C212.341 132.452 215.504 137.93 215.491 142.427L215.396 175.823C215.39 178.053 214.602 179.624 213.33 180.362L216.853 178.314C218.125 177.576 218.914 176.005 218.92 173.775L219.015 140.379C219.027 135.882 215.865 130.404 211.957 128.148Z",
    fill: "#26C642"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.432 130.196C212.339 132.452 215.502 137.93 215.49 142.427L215.395 175.823C215.382 180.313 212.199 182.127 208.291 179.871L192.003 170.467L183.496 182.435L175.078 160.696L158.797 151.296C154.883 149.036 151.72 143.558 151.733 139.068L151.828 105.673C151.84 101.175 155.024 99.3613 158.938 101.621L208.432 130.196Z",
    fill: "#4CD964"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.97 142.593C200.095 143.242 201.005 144.819 201.001 146.112L200.965 159.158C200.961 160.451 200.045 160.973 198.919 160.323L196.722 159.054L197.963 165.678L194.054 157.514L179.979 149.388C178.845 148.734 177.935 147.157 177.939 145.864L177.952 140.853L177.976 132.818C177.979 131.525 178.895 131.002 180.03 131.657L186.003 135.107L198.97 142.593Z",
    fill: "#B8E986"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.986 126.576C185.112 127.225 186.021 128.802 186.018 130.096L186.004 135.106L180.03 131.657C178.895 131.002 177.979 131.524 177.976 132.817L177.953 140.852L169.852 136.176L165.909 139.805L167.184 134.636L164.996 133.372C163.861 132.717 162.951 131.131 162.955 129.837L162.992 116.801C162.995 115.508 163.911 114.986 165.046 115.64L183.986 126.576Z",
    fill: "#F1F1F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8349 100.197C54.9819 98.9582 56.7249 99.9512 56.7319 102.418C56.7389 104.885 55.0069 107.884 52.8599 109.125C50.7129 110.364 48.9699 109.371 48.9629 106.904C48.9559 104.436 50.6879 101.437 52.8349 100.197Z",
    fill: "#F1F1F1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8349 83.626C54.9819 82.386 56.7249 83.38 56.7319 85.847C56.7389 88.314 55.0069 91.313 52.8599 92.553C50.7129 93.793 48.9699 92.8 48.9629 90.332C48.9559 87.865 50.6879 84.866 52.8349 83.626Z",
    fill: "#F1F1F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4121 249.345C25.5591 248.105 27.3021 249.098 27.3091 251.566C27.3161 254.032 25.5841 257.032 23.4371 258.272C21.2901 259.512 19.5471 258.518 19.5401 256.051C19.5331 253.584 21.2651 250.584 23.4121 249.345Z",
    fill: "#F1F1F1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4121 232.773C25.5591 231.533 27.3021 232.526 27.3091 234.994C27.3161 237.46 25.5841 240.46 23.4371 241.7C21.2901 242.939 19.5471 241.946 19.5401 239.479C19.5331 237.011 21.2651 234.012 23.4121 232.773Z",
    fill: "#F1F1F1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9404 128.259C36.0874 127.02 37.8304 128.013 37.8374 130.48C37.8444 132.947 36.1124 135.946 33.9654 137.187C31.8184 138.426 30.0754 137.433 30.0684 134.965C30.0614 132.498 31.7934 129.499 33.9404 128.259Z",
    fill: "#F1F1F1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9404 111.688C36.0874 110.449 37.8304 111.442 37.8374 113.909C37.8444 116.376 36.1124 119.375 33.9654 120.615C31.8184 121.855 30.0754 120.862 30.0684 118.394C30.0614 115.927 31.7934 112.927 33.9404 111.688Z",
    fill: "#F1F1F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8349 67.0548C54.9819 65.8148 56.7249 66.8078 56.7319 69.2758C56.7389 71.7428 55.0069 74.7418 52.8599 75.9818C50.7129 77.2218 48.9699 76.2278 48.9629 73.7608C48.9559 71.2938 50.6879 68.2938 52.8349 67.0548Z",
    fill: "#F1F1F1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9752 235.947L40.7652 233.5L29.8672 211.249L34.0772 213.696L44.9752 235.947Z",
    fill: "#4CD964"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.617 123.777C80.934 120.708 85.258 123.172 85.275 129.281L85.399 172.985C85.416 179.094 81.121 186.536 75.804 189.605L55.719 201.201L44.975 235.947L34.077 213.696L13.992 225.292C8.67599 228.362 4.35199 225.897 4.33399 219.788L4.21099 176.084C4.19299 169.974 8.48899 162.534 13.806 159.464L75.617 123.777Z",
    fill: "#26C642"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 120,
    width: 83,
    height: 106
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 120.01H82.467V225.963H0V120.01Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.257 120.66C76.507 119.642 74.0821 119.786 71.4071 121.331L9.59505 157.017C4.27805 160.087 -0.0169497 167.528 5.02919e-05 173.638L0.12405 217.342C0.13205 220.377 1.20405 222.512 2.93205 223.516L7.14205 225.963C5.41505 224.959 4.34305 222.823 4.33405 219.788L4.21105 176.084C4.19305 169.974 8.48905 162.534 13.8061 159.464L75.6171 123.777C78.2931 122.232 80.716 122.089 82.467 123.106L78.257 120.66Z",
    fill: "#4CD964"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1269 149.017C70.2739 147.778 72.0169 148.771 72.0239 151.238C72.0309 153.705 70.2999 156.704 68.1519 157.945C66.0049 159.184 64.2619 158.191 64.2549 155.723C64.2489 153.256 65.9799 150.257 68.1269 149.017Z",
    fill: "#F1F1F1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7197 155.603C58.8667 154.364 60.6097 155.357 60.6167 157.825C60.6237 160.291 58.8917 163.29 56.7447 164.531C54.5977 165.77 52.8547 164.777 52.8477 162.31C52.8407 159.842 54.5727 156.843 56.7197 155.603Z",
    fill: "#F1F1F1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3125 162.189C47.4515 160.954 49.2025 161.942 49.2095 164.41C49.2165 166.876 47.4765 169.881 45.3375 171.116C43.1905 172.355 41.4475 171.362 41.4405 168.895C41.4335 166.427 43.1655 163.428 45.3125 162.189Z",
    fill: "#F1F1F1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8964 168.78C36.0434 167.54 37.7864 168.533 37.7934 171.001C37.8004 173.467 36.0694 176.467 33.9214 177.707C31.7744 178.947 30.0314 177.953 30.0244 175.486C30.0174 173.019 31.7494 170.019 33.8964 168.78Z",
    fill: "#F1F1F1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4882 175.366C24.6352 174.127 26.3792 175.12 26.3852 177.587C26.3922 180.054 24.6612 183.053 22.5132 184.293C20.3662 185.533 18.6232 184.54 18.6162 182.072C18.6102 179.605 20.3412 176.605 22.4882 175.366Z",
    fill: "#F1F1F1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1718 164.573C70.3188 163.334 72.0618 164.336 72.0688 166.794C72.0758 169.261 70.3438 172.27 68.1968 173.51C66.0498 174.75 64.3068 173.747 64.2998 171.279C64.2928 168.822 66.0248 165.812 68.1718 164.573Z",
    fill: "#B8E986"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7636 171.159C58.9106 169.92 60.6536 170.923 60.6606 173.381C60.6676 175.847 58.9356 178.856 56.7886 180.096C54.6416 181.336 52.8986 180.333 52.8916 177.866C52.8846 175.408 54.6166 172.399 56.7636 171.159Z",
    fill: "#B8E986"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3564 177.746C47.4954 176.511 49.2464 177.509 49.2534 179.967C49.2604 182.433 47.5214 185.447 45.3814 186.683C43.2344 187.922 41.4914 186.919 41.4844 184.452C41.4774 181.994 43.2094 178.985 45.3564 177.746Z",
    fill: "#B8E986"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9404 184.337C36.0874 183.097 37.8304 184.1 37.8374 186.558C37.8444 189.024 36.1124 192.033 33.9654 193.274C31.8184 194.513 30.0754 193.51 30.0684 191.043C30.0614 188.585 31.7934 185.576 33.9404 184.337Z",
    fill: "#B8E986"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5332 190.923C24.6802 189.684 26.4232 190.686 26.4302 193.144C26.4372 195.611 24.7052 198.62 22.5582 199.86C20.4112 201.099 18.6682 200.097 18.6612 197.629C18.6542 195.171 20.3862 192.162 22.5332 190.923Z",
    fill: "#B8E986"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideContact);
export default __webpack_public_path__ + "static/media/slide-contact.c0b1cd236f90120ca77ca00c3b358ab5.svg";
export { ForwardRef as ReactComponent };